"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RemoteFallbackCacheProvider", {
    enumerable: true,
    get: function() {
        return RemoteFallbackCacheProvider;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
class RemoteFallbackCacheProvider {
    async fetch(hash, target) {
        const { logger, remoteCacheProvider, localCacheProvider } = this.options;
        if (localCacheProvider) {
            RemoteFallbackCacheProvider.localHits[hash] = await localCacheProvider.fetch(hash, target);
            logger.silly(`local cache fetch: ${hash} ${RemoteFallbackCacheProvider.localHits[hash]}`);
        }
        if (!RemoteFallbackCacheProvider.localHits[hash] && remoteCacheProvider) {
            RemoteFallbackCacheProvider.remoteHits[hash] = await remoteCacheProvider.fetch(hash, target);
            logger.silly(`remote fallback fetch: ${hash} ${RemoteFallbackCacheProvider.remoteHits[hash]}`);
            // now save this into the localCacheProvider, if available
            if (localCacheProvider && RemoteFallbackCacheProvider.remoteHits[hash]) {
                logger.silly(`local cache put, fetched cache from remote: ${hash}`);
                await localCacheProvider.put(hash, target);
            }
            return RemoteFallbackCacheProvider.remoteHits[hash];
        }
        return RemoteFallbackCacheProvider.localHits[hash];
    }
    async put(hash, target) {
        const { logger, remoteCacheProvider, localCacheProvider, writeRemoteCache } = this.options;
        const putPromises = [];
        // Write local cache if it doesn't already exist, or if the the hash isn't in the localHits
        const shouldWriteLocalCache = !this.isLocalHit(hash) && !!localCacheProvider;
        if (shouldWriteLocalCache) {
            logger.silly(`local cache put: ${hash}`);
            putPromises.push(localCacheProvider.put(hash, target));
        }
        // Write to remote if there is a no hit in the remote cache, and remote cache storage provider, and that the "writeRemoteCache" config flag is set to true
        const shouldWriteRemoteCache = !this.isRemoteHit(hash) && !!remoteCacheProvider && writeRemoteCache;
        if (shouldWriteRemoteCache) {
            logger.silly(`remote fallback put: ${hash}`);
            const remotePut = remoteCacheProvider.put(hash, target);
            putPromises.push(remotePut);
        }
        await Promise.all(putPromises);
    }
    isRemoteHit(hash) {
        return hash in RemoteFallbackCacheProvider.remoteHits && RemoteFallbackCacheProvider.remoteHits[hash];
    }
    isLocalHit(hash) {
        return hash in RemoteFallbackCacheProvider.localHits && RemoteFallbackCacheProvider.localHits[hash];
    }
    async clear() {
        const { localCacheProvider } = this.options;
        if (localCacheProvider) {
            return localCacheProvider.clear();
        }
    }
    async purge(sinceDays) {
        const { localCacheProvider } = this.options;
        if (localCacheProvider) {
            return localCacheProvider.purge(sinceDays);
        }
    }
    constructor(options){
        _define_property(this, "options", void 0);
        this.options = options;
    }
}
_define_property(RemoteFallbackCacheProvider, "localHits", {});
_define_property(RemoteFallbackCacheProvider, "remoteHits", {});
